module.exports = __webpack_public_path__ + "img/content4.6dd5d826.png";